var culture = "";
try {
  var pathName = location.pathname.split("/");

  culture = pathName[1];
} catch (err) {
  console.log(err);
}
var message1 = "امتیاز دهید";

if (culture === "en") {
  message1 = "Rate it";
}

var defaults = {
  TotalNum: 5,
  firstRating: null,
  getScore: true,
  setScore: false,
  getAndSet: false,
  fontIcon: true,
  iclasses: {
    unselect: "fa-circle-o",
    select: "fa-dot-circle-o",
    halfIcon: "fa fa-star-half-o",
  },
  htmlelement: false,
  spanHeight: 20,
  spanWidth: 20,
  writeScore: true,
  writeScoreOptions: {
    writeScoreText: message1,
  },
  dynamicOption: false,
};

export function giveScore(element, options) {
  if (element.length == 0) {
    return;
  }

  if (element.length > 1) {
    element.forEach(function (el) {
      giveScore(el, options);
    });
    return;
  }

  var settings = Object.assign({}, defaults, options);

  var base = element;
  var rate1 = 0;
  var baseRating,
    inputVal,
    objectLebgth,
    objectValue,
    objectText,
    finalHtmlTags = "",
    scoreType,
    selectedScoreNum,
    sc,
    tx;

  function setup() {
    if (settings.firstRating !== null) {
      inputVal = settings.firstRating;
    } else {
      inputVal = base.value;
    }

    base.insertAdjacentHTML("afterend", '<div class="scoresContainer filters-box__stars"></div>');
    base.style.display = "none";

    baseRating = base.nextElementSibling;

    var wrapper = document.createElement("div");
    wrapper.className = "scoreWrapper";
    baseRating.parentNode.insertBefore(wrapper, baseRating);
    wrapper.appendChild(baseRating);

    if (settings.fontIcon) {
      if (settings.dynamicOption) {
        objectLebgth = base.children.length;

        for (var l = 0; l < objectLebgth; l++) {
          objectValue = base.children[l].value;
          objectText = base.children[l].text;

          finalHtmlTags +=
            '<i data-value="' +
            objectValue +
            '"  data-text="' +
            objectText +
            '" class="fa ' +
            settings.iclasses.unselect +
            '"></i>';
        }
      } else {
        objectLebgth = settings.TotalNum;

        for (var i = 0; i < objectLebgth; i++) {
          finalHtmlTags +=
            '<i class="fa ' + settings.iclasses.unselect + '"></i>';
        }
      }

      baseRating.innerHTML = finalHtmlTags;

      if (settings.writeScore) {
        var rateScore = document.createElement("a");
        rateScore.className = "rate_Score";
        rateScore.textContent = settings.writeScoreOptions.writeScoreText;
        baseRating.parentNode.appendChild(rateScore);
        scoreType = baseRating.parentNode.querySelector(".rate_Score");
      }
    } else if (settings.htmlelement) {
      if (settings.writeScore) {
        var rateNume = document.createElement("span");
        rateNume.className = "RateNume";
        rateNume.textContent = inputVal;
        baseRating.appendChild(rateNume);
      }

      for (var e = 0; e < settings.TotalNum; e++) {
        finalHtmlTags +=
          '<span  style="width:' +
          (settings.spanWidth + 2) +
          "px;height:" +
          (settings.spanHeight + 2) +
          'px" class="rateItem">';

        var sel = "";

        for (var j = 0; j < 10; j++) {
          sel += '<i style="width:' + settings.spanWidth / 10 + 'px"></i>';
        }
        finalHtmlTags += sel + "</span>";
      }

      baseRating.innerHTML = finalHtmlTags;
    }
  }

  function writeScore(value, text) {
    if (settings.dynamicOption) {
      if (text !== undefined) {
        baseRating.parentNode.querySelector(".rate_Score").innerHTML = text;
      } else {
        baseRating.parentNode.querySelector(".rate_Score").innerHTML = message1;
      }

      baseRating.value = value;
    } else {
      switch (value) {
        case 1:
        case 2:
          baseRating.parentNode.querySelector(".rate_Score").innerHTML = "بد";
          break;

        case 3:
        case 4:
          baseRating.parentNode.querySelector(".rate_Score").innerHTML = "خوب";
          break;

        case 5:
        case 6:
          baseRating.parentNode.querySelector(".rate_Score").innerHTML = "عالی";
          break;
      }
    }
  }

  function init() {
    setup();

    if (
      (settings.getScore && !settings.setScore && !settings.htmlelement) ||
      (settings.getAndSet && !settings.htmlelement)
    ) {
      if (settings.getAndSet) {
        Array.from(baseRating.children).forEach(function (child, i) {
          if (i < inputVal) {
            child.setAttribute("data-rating", "1");
            child.classList.add(settings.iclasses.select);
            child.classList.remove(settings.iclasses.unselect);
          } else {
            child.setAttribute("data-rating", "0");
          }
        });
        rate1 = 1;
      }

      Array.from(baseRating.children).forEach(function (child) {
        child.addEventListener("mouseenter", function () {
          Array.from(this.parentElement.children).forEach(function (sibling) {
            if (
              sibling === child ||
              sibling.compareDocumentPosition(child) &
                Node.DOCUMENT_POSITION_PRECEDING
            ) {
              sibling.classList.add(settings.iclasses.select);
              sibling.classList.remove(settings.iclasses.unselect);
            } else {
              sibling.classList.remove(settings.iclasses.select);
              sibling.classList.add(settings.iclasses.unselect);
            }
          });

          if (settings.writeScore) {
            if (settings.dynamicOption) {
              sc = child.getAttribute("data-value");
              tx = child.getAttribute("data-text");
            } else {
              sc = Array.from(child.parentElement.children).indexOf(child) + 1;
              tx = "";
            }
            writeScore(sc, tx);
          }
        });

        child.addEventListener("mouseleave", function () {
          if (rate1 === 0) {
            Array.from(this.parentElement.children).forEach(function (sibling) {
              sibling.classList.remove(settings.iclasses.select);
              sibling.classList.add(settings.iclasses.unselect);
            });

            if (settings.writeScore) {
              scoreType.textContent = settings.writeScoreOptions.writeScoreText;
            }
          } else if (rate1 === 1) {
            Array.from(this.parentElement.children).forEach(function (sibling) {
              if (sibling.getAttribute("data-rating") === "0") {
                sibling.classList.remove(settings.iclasses.select);
                sibling.classList.add(settings.iclasses.unselect);
              } else {
                sibling.classList.add(settings.iclasses.select);
                sibling.classList.remove(settings.iclasses.unselect);
              }
            });

            if (settings.writeScore) {
              sc =
                Array.from(
                  baseRating.querySelectorAll("." + settings.iclasses.select)
                ).length + 1;

              if (settings.dynamicOption) {
                tx = baseRating
                  .querySelector("." + settings.iclasses.select + ":last-child")
                  .getAttribute("data-text");
              }
              writeScore(sc, tx);
            }
          }
        });
      });

      Array.from(baseRating.children).forEach(function (child) {
        child.addEventListener("click", function () {
          Array.from(child.parentElement.children).forEach(function (sibling) {
            sibling.setAttribute("data-rating", "0");
            sibling.classList.remove(settings.iclasses.select);
          });

          Array.from(child.parentElement.children).forEach(function (sibling) {
            sibling.setAttribute("data-rating", "1");
            sibling.classList.add(settings.iclasses.select);
          });

          rate1 = 1;
          selectedScoreNum = Array.from(
            baseRating.querySelectorAll("." + settings.iclasses.select)
          ).length;

          if (settings.writeScore) {
            writeScore(selectedScoreNum, child.getAttribute("data-text"));
          }

          if (typeof inputVal !== "undefined" && inputVal !== false) {
            base.value = selectedScoreNum;
          }
        });
      });
    } else if (settings.setScore && !settings.getScore) {
      if (settings.htmlelement && !settings.fontIcon) {
        inputVal = inputVal.split(".");
        var integerPart = parseInt(inputVal[0], 10);
        var decimalPart = parseInt(inputVal[1], 10) || 0;

        Array.from(baseRating.querySelectorAll(".rateItem")).forEach(function (
          item,
          i
        ) {
          if (i < integerPart) {
            item.classList.add("fillColor");
          }
        });

        if (integerPart === 0 && decimalPart > 0) {
          baseRating.querySelector(".rateItem").classList.add("min");
        }

        Array.from(baseRating.querySelectorAll(".min > i")).forEach(function (
          icon,
          i
        ) {
          if (i < decimalPart) {
            icon.classList.add("on");
          }
        });
      } else if (!settings.htmlelement && settings.fontIcon) {
        var inputValRoundDown = Math.floor(inputVal);

        Array.from(baseRating.children).forEach(function (child, i) {
          if (i < inputValRoundDown) {
            child.setAttribute("data-rating", "1");
            child.classList.add(settings.iclasses.select);
            child.classList.remove(settings.iclasses.unselect);
          } else {
            var halfIcon = document.createElement("i");
            halfIcon.style.width = child.style.width;
            halfIcon.style.height = child.style.height;
            halfIcon.classList.add(settings.iclasses.halfIcon);
            child.appendChild(halfIcon);
            return false;
          }
        });
      }
    }
  }

  init();

  // function isInt(n) {
  //   return Number(n) === n && n % 1 === 0;
  // }
}
